import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from 'semantic-ui-react';
import 'PointOfSale/styles/components/cepCard.less';

const TotalMeals = ({ count, onClickServe }) => {
  return (
    <Grid padded className="text-center">
      <Grid.Row>
        <Grid.Column>
          <div className="cep-counter">{count}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Button
          fluid
          className="cep-serve-button"
          content="Serve"
          onClick={() => onClickServe(1, false)}
        />
      </Grid.Row>
    </Grid>
  );
};

TotalMeals.propTypes = {
  count: PropTypes.number,
  onClickServe: PropTypes.func,
};
export default TotalMeals;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/component/TotalMeals.js